
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal,  } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Papa from 'papaparse';
import Swal from 'sweetalert2';
import { adminAttendanceBulk } from '../../../service/bulkUploadService';

const BulkUploadModal = ({ onUploadData,isVisible, handleCancel ,setLoading,setProgress}) => {
    const [file, setFile] = useState(null);
const handleUpload = async () => {
    let interval = null; // Declare interval here
    try {
        setLoading(true);
        setProgress(1);
        handleCancel();
        let currentProgress = 1;

        interval = setInterval(() => {
            if (currentProgress < 95) {
                currentProgress += 1;
                setProgress(currentProgress);
            }
        }, 50);

        if (!file) {
            clearInterval(interval);
            setProgress(0);
            setLoading(false);
            showWarning("Please select a file");
            return;
        }

        await adminAttendanceBulk(file);
        clearInterval(interval);
        setProgress(100);
        setLoading(false);
        onUploadData();
    } catch (error) {
        console.error("Error in handleUpload:", error.message, error.stack);
        if (interval) clearInterval(interval); // Safely clear interval
        setProgress(0);
        setLoading(false);
        showWarning(error.message || "Failed to upload file");
    }
};

    const handleReset = () => {
        setFile(null);
        document.getElementById('csvId').value = ""; // Reset file input
    }

    const handleBulkUpload = async (event) => {
        try {


            setFile(event.target.files[0]);
            
        } catch (error) {
            console.error("Error in file uploading:", error);
        }
    };

    const showWarning = (str) => {
        return Swal.fire({
            title: "Error",
            text: str,
            icon: "error",
        });
    };

    const downloadSampleFile = () => {
        const sampleData = [
            ["Record No", "Epf No", "Date", "Clock In","Clock Out"],
            ["1", "1234", "20/8/2025", "08:00:00","17:00:00"]
        ];
        const csvString = Papa.unparse(sampleData);
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

        // Create a temporary link to download the CSV
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", "sample.csv"); // Specify file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up the temporary link
    };


    return (
        <Modal
            zIndex={200000}
            open={isVisible}
            onCancel={handleCancel}
            footer={null}
            maskClosable={false}
            closable={false}
        >
            <div className="modal-content">
                <div className="page-wrapper-new p-0">
                    <div className="content">
                        <div className="modal-header border-0 custom-modal-header">
                            <div className="page-title">
                                <h4>Bulk Upload</h4>
                                <p className="mb-0">Select a file to upload</p>
                            </div>
                        </div>

                        <div className="modal-body custom-modal-body">
                            <div className='content'>
                                <div className='' style={{ fontStyle: "italic" }}>*Required field labels</div>
                                <p className='mt-1' style={{ textAlign: "justify" }}>
                                   The correct column order is (record_number, epf_number, date, time)
                                </p>
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }} className="mt-3">
                                <div className="mb-3 input-blocks" style={{ flex: 1, marginRight: "20px" }}>
                                    <label className="form-label">File Upload</label>
                                    <input
                                        type="file"
                                        className="form-control mt-0"
                                        onChange={handleBulkUpload}
                                        id='csvId'
                                        accept='.csv'
                                    />
                                </div>
                                <div className="mb-3 input-blocks">
                                    <label className="form-label pl-0">Sample File</label>
                                    <button className='btn pe-6 download-btn'
                                            onClick={downloadSampleFile}
                                    >Download <DownloadOutlined /></button>
                                </div>
                            </div>
                            <div className="pt-3" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <button
                                    type="button"
                                    className="btn btn-cancel"
                                    onClick={handleCancel}
                                >
                                    Close
                                </button>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-cancel me-2"
                                        onClick={handleReset}
                                        //disabled={loading}
                                    >
                                        {/* {loading ? <Spin size='small' /> : "Reset"} */}
                                        Reset
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-submit ml-0"
                                        onClick={handleUpload}
                                    >
                                       Upload
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

BulkUploadModal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
    onUploadData:PropTypes.func.isRequired,
    setProgress:PropTypes.func.isRequired,
    setLoading:PropTypes.func.isRequired
};

export default BulkUploadModal;
